import { Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

type ProfileActionBarProps = {
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
};

export const ProfileActionBar = ({
  onConfirm,
  onCancel,
  confirmLabel = 'Concluído',
  cancelLabel = 'Cancelar',
}: ProfileActionBarProps) => {
  return (
    <View style={styles.container}>
      <Pressable
        accessibilityRole="button"
        onPress={onConfirm}
        style={[styles.button, styles.confirmButton]}>
        <Text style={styles.btnText}>{confirmLabel}</Text>
      </Pressable>

      <Pressable
        accessibilityRole="button"
        onPress={onCancel}
        style={[styles.button, styles.cancelButton]}>
        <Text style={styles.btnText}>{cancelLabel}</Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: calcSizeForDevice(348),
    flexDirection: 'row',
    gap: calcSizeForDevice(12),
  },
  button: {
    flex: 1,
    height: calcSizeForDevice(44, 52),
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: calcSizeForDevice(12),
    paddingHorizontal: calcSizeForDevice(40),
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
  },
  confirmButton: {
    backgroundColor: 'rgba(6, 113, 224, 0.15)',
    marginRight: 'auto',
  },
  cancelButton: {
    backgroundColor: 'transparent',
  },
  btnText: {
    fontSize: calcSizeForDevice(20),
    fontWeight: '600',
    color: '#FFF',
  },
});
